Vue.component("invite-multiple-colleagues", {
    template: `
  <form role="form">
          
    <div class="form-group d-flex align-items-center justify-content-center">
      <label class="header-case" for="invite-colleageus-email-1">Email #1</label>
      <input type="text" id="invite-colleageus-email-1" class="form-control" placeholder="Enter their email" name="email" v-model="form.email"/>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" name="admin" id="admin" v-model="form.admin"/>
        <label for="admin" class="custom-control-label">Invite as admin</label>
      </div>
    </div>

    <div class="form-group d-flex align-items-center justify-content-center">
      <label class="header-case" for="invite-colleageus-email-2">Email #2</label>
      <input type="text" id="invite-colleageus-email-2" placeholder="(Optional)" class="form-control" name="email" v-model="form.email_secondary"/>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" name="admin2" id="admin_secondary" v-model="form.admin_secondary"/>
        <label for="admin_secondary" class="custom-control-label">Invite as admin</label>
      </div>
    </div>

    <div class="text-right">
      <button class="btn btn-transparent" @click.prevent="cancel">Skip This Step</button>
      <button class="btn btn-primary" @click.prevent="submitForm" :disabled="form.busy">
        <span v-if="form.busy">
            <i class="fa fa-btn fa-spinner fa-spin"></i> {{__('SENDING..')}}
        </span>
        <span v-else>
          Send invitations
        </span>
      </button>
    </div>

  </form>
  `,
    data() {
        return {
            form: new SparkForm({
                email1: "",
                admin1: false,
                email2: "",
                admin2: false
            })
        };
    },

    methods: {
        submitForm() {
            let endpoint = `/settings/hotels/${
                Spark.state.currentTeam.id
            }/multiple-invitations`;

            console.log(endpoint);

            Spark.post(endpoint, this.form).then(response => {
                this.success();
            });
        },
        success() {
            this.$eventHub.$emit("multipleInvitationsAction", "success");
        },
        cancel() {
            this.$eventHub.$emit("multipleInvitationsAction", "cancel");
        }
    }
});
